// extracted by mini-css-extract-plugin
export default {"container":"partner-video_container__dVBmy","video":"partner-video_video__lLyoA","name":"partner-video_name__yWE85"};